import { findModuleDefinition } from '@platform/modularity/moduleDefinitionRegistry';
import { isArticleType } from '../../tabs/article/articleToc';

/**
 * Вкладка запису за посиланням `rec:` статті (прототип mdClick: стаття бази знань — «Читання», решта — «Загальне»): «Читання», коли тип
 * цілі — стаття за визначенням завантаженого пакета модуля; інакше типова вкладка (undefined).
 */
export function mdRecordTab(module: string, rt: string): string | undefined {
  const target = findModuleDefinition(module)?.recordTypes.find((r) => r.key === rt);
  return target && isArticleType(target) ? 'read' : undefined;
}
